import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../assets/css/CsHome.css";
import SearchIcon from "@mui/icons-material/Search";
import HeadPhone from "../assets/images/headphones.png";
import CircularProgress from "@mui/material/CircularProgress"; // استيراد مؤشر التحميل الدائري

import NavBar from "../components/NavBar";

const CsHome = () => {
  const [loading, setLoading] = useState(false);
  const [shipmentNumber, setShipmentNumber] = useState(""); // لحفظ رقم الشحنة المدخل
  const [shipmentDetails, setShipmentDetails] = useState(null); // لحفظ نتيجة الـ API
  const [error, setError] = useState(null); // لحفظ الخطأ إذا وُجد
  const navigate = useNavigate();

  const handleSearch = async () => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    if (!shipmentNumber) {
      alert("Please enter a shipment number!");
      return;
    }

    setLoading(true); // تفعيل حالة التحميل

    try {
      const response = await axios.get(
        `https://vsoftapi.com-eg.net/api/ClientUsers/V6/GetShipmentDetails/${shipmentNumber}`,
        {
          headers: {
            CompanyID: userData.Data.CompanyID,
            AccessToken: userData.Data.AccessToken,
          },
        }
      );

      if (response.data) {
        const resData = response.data;
        const shipmentDetails = resData.shipmentInfo || resData.ShipmentInfo;
        const shipmentTracking = resData.tracking || resData.Tracking;
        const shipmentComplaint = resData.complaints || resData.Complaints;
        const ComplaintsActions = resData.complaintsActions || resData.ComplaintsActions;

        if (shipmentDetails && shipmentDetails.length > 0) {
          navigate("/shipment-details", {
            state: {
              shipmentDetails,
              shipmentTracking: shipmentTracking || [],
              shipmentComplaint: shipmentComplaint || [],
              ComplaintsActions: ComplaintsActions || [],
            },
          });
          setShipmentDetails(shipmentDetails[0]);
          setError(null);
        } else {
          setError("Error 404: Shipment not found.");
          setShipmentDetails(null);
        }
      } else {
        setError("Error 404: Shipment not found.");
        setShipmentDetails(null);
      }
    } catch (err) {
      console.error("API Error:", err);
      setError("Error 404: Shipment not found.");
      setShipmentDetails(null);
    } finally {
      setLoading(false); // إيقاف حالة التحميل
    }
  };

  const handleRetry = () => {
    setError(null);
    navigate("/general-inquiry");
  };

  const handleGoHome = () => {
    navigate("/data-entry");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <>
      <NavBar />
      <div className="home-container">
      <div className="container">
        <div className="logo">
          <img src={HeadPhone} alt="Call Center Logo" />
        </div>
        <div className="search-box">
          <button
            className="search-button"
            onClick={handleSearch}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} style={{ color: "white" }} />
            ) : (
              <SearchIcon style={{ color: "white" }} />
            )}
          </button>
          <input
            type="text"
            className="search-input"
            placeholder="Enter Shipment Number"
            value={shipmentNumber}
            onChange={(e) => setShipmentNumber(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={loading}
          />
        </div>

        {loading && (
          <div className="loading-container">
            <CircularProgress size={50} style={{ color: "#007bff" }} />
          </div>
        )}

        {shipmentDetails && (
          <div className="shipment-details">
            <h3>Shipment Details:</h3>
            <pre>{JSON.stringify(shipmentDetails, null, 2)}</pre>
          </div>
        )}

        {error && (
          <div className="error-message-display" style={{ color: "#ef4b1f", marginTop: "20px", fontWeight: "bold", fontSize: "1.1rem" }}>
            {error}
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default CsHome;
